import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { TenantDto } from '@careapp-group/ng-sdk';
import { Observable, Subscription } from 'rxjs';
import slugify from 'slugify';

import { FormCoreComponent } from '../form-core';
import { FormMode } from '../../constants';
import { countryCodeData } from '../../../profile/edit-phone-number/country-codes';
import { State } from '../../../store';
import { Store } from '@ngrx/store';
import { getPreferredCountries } from '../../../store/remote-config/remote-config.selectors';

@Component({
    selector: 'tenant-form',
    templateUrl: './tenant-form.component.html',
    styleUrls: ['./tenant-form.component.scss'],
    standalone: false
})
export class TenantFormComponent extends FormCoreComponent<TenantDto> implements OnInit, OnDestroy {
  _readOnly = false;
  nameSubscription: Subscription;
  urlSlugPattern: string = '^[a-z0-9]+(?:-[a-z0-9]+)*$';
  urlSlugRegExp: RegExp = new RegExp(this.urlSlugPattern);

  preferredCountries$: Observable<string[]>;
  countryCodeData = countryCodeData;
  countryCodeList = Object.keys(countryCodeData);

  @Input() set readOnly(value: boolean) {
    if (value && value === true) {
      this.form.disable();
      this._readOnly = true;
    }
  }
  @Input()
  set tenant(value: TenantDto) {
    if (value) {
      const result = { ...value };
      this.form.patchValue(result || {}, { emitEvent: false, onlySelf: true });
    }
  }

  nameControl = new UntypedFormControl('', Validators.required);
  idControl = new UntypedFormControl('', [
    Validators.required,
    Validators.pattern(this.urlSlugRegExp),
  ]);
  enabledControl = new UntypedFormControl(true);

  constructor(private store: Store<State>) {
    super();
    this.form = new UntypedFormGroup({
      id: this.idControl,
      name: this.nameControl,
      enabled: this.enabledControl,
      country: new UntypedFormControl('', Validators.required),
    });
    this.nameSubscription = this.form.controls['name'].valueChanges.subscribe((val) => {
      let newVal = slugify(val, {
        replacement: '-',
        lower: true,
        remove: /[*+~.()'"!:@]/g,
        strict: true,
        locale: 'en',
      });
      if (this.mode === FormMode.CREATE) {
        this.form.controls['id'].setValue(newVal);
        this.form.controls['id'].markAsTouched();
      }
    });
  }
  ngOnInit() {
    this.preferredCountries$ = this.store.select(getPreferredCountries);
  }
  ngOnDestroy(): void {
    this.nameSubscription.unsubscribe();
  }
}
